import clsx from 'clsx'
import { MdDragIndicator } from 'react-icons/md'
import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { cn } from 'components/UI/cn'
import { SalesStage } from 'models/sales_stages'
import getStageColor from 'utils/getStageColor'

export interface StageDragAndDropItemProps {
  id: number
  stage: SalesStage
  onMoveUp: () => void
  onMoveDown: () => void
  isFirst: boolean
  isLast: boolean
  disabled?: boolean
}

export function StageDragAndDropItem({
  id,
  stage,
  onMoveUp,
  onMoveDown,
  isFirst,
  isLast,
  disabled = false,
}: StageDragAndDropItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  const [backgroundColor] = getStageColor(stage.win_rate || 0)

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={clsx('px-3 my-1 rounded bg-[#E8F0EC]')}
    >
      <div className="justify-between items-center flex py-3">
        <div className="flex items-center gap-3">
          <div
            {...attributes}
            {...listeners}
            className={disabled ? 'opacity-30 cursor-not-allowed' : ''}
          >
            <MdDragIndicator
              size={17}
              className={
                disabled
                  ? 'text-[#414942] cursor-not-allowed'
                  : 'text-[#414942] hover:cursor-move'
              }
            />
          </div>
          <div
            className="w-3 h-3 rounded-full flex-shrink-0"
            style={{ backgroundColor }}
          />
          <div className="font-medium">{stage.stage}</div>
          {stage.win_rate !== null && (
            <div className="text-sm text-gray-500">
              ({stage.win_rate}% win rate)
            </div>
          )}
        </div>
        <div className="flex flex-row items-center gap-1">
          <div
            className={cn('rounded h-7 w-7 flex items-center justify-center', {
              invisible: isFirst,
              'cursor-pointer hover:bg-[#2B6A4633]': !disabled,
              'opacity-30 cursor-not-allowed': disabled,
            })}
            onClick={disabled ? undefined : onMoveUp}
          >
            <IoMdArrowDropup size={20} className="text-[#414942]" />
          </div>
          <div
            className={cn('rounded h-7 w-7 flex items-center justify-center', {
              invisible: isLast,
              'cursor-pointer hover:bg-[#2B6A4633]': !disabled,
              'opacity-30 cursor-not-allowed': disabled,
            })}
            onClick={disabled ? undefined : onMoveDown}
          >
            <IoMdArrowDropdown size={20} className="text-[#414942]" />
          </div>
        </div>
      </div>
    </div>
  )
}
